import { useEvidencePermission } from '@utils/permission-hook';
import React from 'react';
import { Evidence } from '@eas/common-web';
import { useAuthoredEvidence } from '@components/evidence/authored-evidence';
import { EducationCycle } from '@models';
import { EvidenceApiUrl, Permission } from '@enums';
import { useColumns } from './education-cycle-columns';
import { Fields } from './education-cycle-fields';
import { useValidationSchema } from './education-cycle-schema';

export function EducationCycles() {
  const columns = useColumns();
  const validationSchema = useValidationSchema();

  const permissions = useEvidencePermission([Permission.BO_EDUCATION_MANAGE]);

  const evidence = useAuthoredEvidence<EducationCycle>({
    version: 2,
    identifier: 'EDUCATION_CYCLES',
    apiProps: {
      url: EvidenceApiUrl.EDUCATION_CYCLE,
    },
    tableProps: {
      columns,
      tableName: 'Vzdelávací cykly',
      showBulkActionButton: false,
      showReportButton: false,
    },
    detailProps: {
      FieldsComponent: Fields,
      toolbarProps: {
        title: 'Vzdelávací cyklus',
        showBtn: permissions,
      },
      validationSchema,
    },
  });

  return <Evidence {...evidence} />;
}
